// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C58f","colBig":"styles_colBig__GFD8w","colSmall":"styles_colSmall__LeBRi"};